
import './anniversary.css';

function AnniversaryDinner() {
  return (
    <div className="anni-page">
      {/* Full-width top info bar */}
      <div className="anni-topbar">
        <div className="anni-topbar-inner">
          <div className="anni-topbar-group">
            <span className="anni-topbar-item">📍 2769 Duluth Hwy, Duluth, GA 30096</span>
            <span className="anni-topbar-item">📞 <b>678-920-6669</b></span>
            <span className="anni-topbar-item">✉️ info@yugalkunj.org</span>
          </div>

        </div>
      </div>

      {/* Full-width header bar with logo and donate button (no menu) */}
      <div className="anni-headerbar">
        <div className="anni-headerbar-inner">
          <div className="anni-brand">
            <img src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png" alt="YugalKunj" />
            {/* <div className="anni-brand-title">YugalKunj</div> */}
          </div>
          <div className="anni-actions">
            {/* <a className="anni-donate" href='/rms/'>
              DONATE NOW
            </a> */}
            <a
              className="anni-button"
              href='/annreg/'
              onClick={(e) => { e.preventDefault(); if (typeof window !== 'undefined') window.location.assign('/annreg/'); }}
            >
              Reserve Your Spot
            </a>
          </div>
        </div>
      </div>


      {/* Top banner with subtle pattern and gold border here */}
      <header className="anni-header">
        <div className="anni-pattern" aria-hidden="true" />
        <div className="anni-container">
          <div className="anni-card an-anim">
            {/* <img
              src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png"
              alt="YugalKunj Logo"
              style={{ display: 'block', margin: '0 auto 0.75rem', height: '72px', width: 'auto' }}
              loading="eager"
              decoding="async"
            /> */}
            <div className="anni-divider" />
            <h1 className="anni-title">
              <span role="img" aria-label="floral">🌸</span> Celebration of 10 Glorious Years of Yugal Kunj  <span role="img" aria-label="floral">🌸</span>
            </h1>
            <p className="anni-subtitle">Join us in celebrating 10 years of our beloved temple.</p>
            <a
              className="anni-button"
              href='/annreg/'
              onClick={(e) => { e.preventDefault(); if (typeof window !== 'undefined') window.location.assign('/annreg/'); }}
            >
              Reserve Your Spot
            </a>
          </div>
        </div>
      </header>

      {/* Flyer placeholder section */}
      <section className="anni-flyer">
        <div className="anni-flyer-inner">
          <div className="anni-flyer-placeholder">
            <a

              href='/annreg/'
              onClick={(e) => { e.preventDefault(); if (typeof window !== 'undefined') window.location.assign('/annreg/'); }}
            >


              <img src='http://yugalkunj.org/images/flyerannreg.jpg' alt='yugalkunj flyer' />
              {/* <img src='https://yugalkunj.org/images/flyerann2.jpg' alt='yugalkunj flyer' /> */}
            </a>
          </div>
        </div>
      </section>

      {/* Invitation card */}
      <main className="anni-section">
        <section className="anni-card2 an-anim">
          {/* Gold top border */}
          <div className="anni-bar" />

          <div className="anni-inner">
            {/* Event details */}
            <div className="anni-grid">
              <div className="anni-item">
                <div className="anni-item-emoji" aria-hidden>📅</div>
                <div>
                  <p className="anni-item-label">Date</p>
                  <p className="anni-item-value">Saturday, August 30, 2025</p>
                </div>

              </div>
              <div className="anni-item">
                <div className="anni-item-emoji" aria-hidden>🕕</div>
                <div>
                  <p className="anni-item-label">Time</p>
                  <p className="anni-item-value">6:00 PM – 9:00 PM</p>
                </div>
              </div>
              <div className="anni-item">
                <div className="anni-item-emoji" aria-hidden>📍</div>
                <div>
                  <p className="anni-item-label">Location</p>
                  <p className="anni-item-value">Yugal Kunj - Radha Krishna Temple and Community Center 2769 Duluth Hwy, Duluth, GA 30096</p>
                </div>
              </div>
            </div>

            {/* Divider */}
            <hr className="anni-hr" />

            {/* Invitation paragraph */}
            <p className="anni-paragraph">
              We warmly invite you, your family, and friends to join this special dinner as we honor a decade of devotion and community service. Your presence and generous support help sustain the temple's spiritual programs, cultural activities, & charitable initiatives. Together, let us celebrate with gratitude & joy.
            </p>
            <a
              className="anni-button"
              href='/annreg/'
              onClick={(e) => { e.preventDefault(); if (typeof window !== 'undefined') window.location.assign('/annreg/'); }}
            >
              Reserve Your Spot
            </a>

            {/* CTA moved to header */}
          </div>


          <div className="anni-bar" />
        </section>

        {/* Footer */}
        <footer className="anni-footer">
          With gratitude, <b>YugalKunj</b>
        </footer>
      </main>
    </div>
  );
}

export default AnniversaryDinner;
